import React from 'react';

class Header extends React.Component {
    render() {
        return (
            <header>
                <img src={require("../images/logo.png")} alt="Best Place To Work" />
                <h1>Best Place to Work</h1>
                <p>All information provided and your details will be kept in strict confidence and never shared with your employer.</p>
            </header>
        )
    }
}

export default Header;